import useTipHelper from "../hooks/useTipHelper";
import Tour from "./Tour";

export default function Tips() {
  useTipHelper();

  return <Tour />;
}
